import React from 'react';

import Image from 'marketing-website/components/modules/Image';
import ZincLogo from 'marketing-website/media/images/pages/case-studies/zinc/zinc-full@2x.png';

export default function ZincFull() {
  return <Image maxWidth={80} src={ZincLogo} hasShadow={false} />;
}



// WEBPACK FOOTER //
// ./src/components/icons/ZincFull/index.js